import axios from '@Services/axios';

export const FAMILY_GET_LOADING = 'family/FAMILY_GET_LOADING';
export const FAMILY_GET_SUCCESS = 'family/FAMILY_GET_SUCCESS';
export const FAMILY_GET_ERROR = 'family/FAMILY_GET_ERROR';


const initialState = {
    families: [],
    
    isGetInProgress: false,
    isGetComplete: false,
    
    error: ''
};

export function reduxThunkReducer(state = initialState, action) {
    switch (action.type) {
        
        case FAMILY_GET_LOADING: {
            return {
                ...state,
                isGetInProgress: true,
                isGetComplete: false,
                error: '',
            };
        }
        case FAMILY_GET_SUCCESS: {
            return {
                ...state,
                isGetInProgress: false,
                isGetComplete: true,
                families: action?.families || [],
            };
        }
        case FAMILY_GET_ERROR: {
            return {
                ...state,
                isGetInProgress: false,
                isGetComplete: false,
                error: action?.error || '',
            };
        }
        default: {
            return {...state};
        }
    }
}

////////////////////////////////////////////////////////////////////
const URL_API = process.env.REACT_APP_API_ENDPOINT;

export const getFamilies = (allElements) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({ 
      type: FAMILY_GET_LOADING
    });
    axios.post(`${URL_API}/listeFamilles`,
      {}).then(
      response => {
        console.log("response LISTE FAMILLE", response?.data?.données);

        if (response?.data?.données) {
          const data = response?.data?.données;
          const families = [];
          if (allElements) {
            families.push({value: 0, label: 'Tous les produits'});
          }
          data.map((oneFamily, index) => {
            families.push({value: oneFamily?.id || 0, label: oneFamily?.libellé || ''});
          });

          dispatch({ 
            type: FAMILY_GET_SUCCESS,
            families: families
          });
        } else {
          dispatch({ type: FAMILY_GET_ERROR, error: "Erreur lors de la récupération de la liste des familles" });
        }
    },
    error => {
      dispatch({ type: FAMILY_GET_ERROR, error: error?.response?.data });
    });
      
  };
};

